import React, { useState, useEffect } from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import { toast } from 'react-toastify';
import { FaTrash, FaPlus, FaTimes } from 'react-icons/fa';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import * as api from '~/Services/Service';

const ModalValidarCotacao = ({ show, codigoAtivo, onClose }) => {
  const [validadores, setValidadores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [novoUsuario, setNovoUsuario] = useState(null);
  const [adicionando, setAdicionando] = useState(false);

  useEffect(() => {
    if (show) carregarValidadores();
  }, [show]);

  const carregarValidadores = async () => {
    setLoading(true);
    try {
      const resp = await api.ativoManutencaoListarValidadoresCotacao(codigoAtivo);
      setValidadores(resp || []);
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao carregar validadores';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const loadUsuarios = async (inputValue) => {
    if (!inputValue || inputValue.length < 2) return [];
    try {
      const resp = await api.buscarUsuariosPorTermo(inputValue);
      return (resp || []).map((u) => ({ value: u.codigo, label: u.nome }));
    } catch (e) {
      return [];
    }
  };

  const handleAdicionar = async () => {
    if (!novoUsuario) return;
    setAdicionando(true);
    try {
      await api.ativoManutencaoSalvarValidadorCotacao({ codigo_ativo: codigoAtivo, codigo_usuario: novoUsuario.value });
      toast.success('Validador adicionado');
      setNovoUsuario(null);
      carregarValidadores();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao adicionar validador';
      toast.error(msg);
    } finally {
      setAdicionando(false);
    }
  };

  const handleExcluir = async (codigoUsuario) => {
    try {
      await api.ativoManutencaoExcluirValidadorCotacao({ codigo_ativo: codigoAtivo, codigo_usuario: codigoUsuario });
      toast.success('Validador removido');
      carregarValidadores();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao remover validador';
      toast.error(msg);
    }
  };

  return (
    <Modal show={show} onHide={onClose} size="lg" centered backdrop="static">
      <Modal.Header closeButton style={{ backgroundColor: '#0747a6', color: '#fff' }}>
        <Modal.Title style={{ color: '#fff', fontSize: 16 }}>Validadores de Cotação</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex mb-3" style={{ gap: 8, maxWidth: 500 }}>
          <div style={{ flex: 1 }}>
            <AsyncSelect
              cacheOptions
              loadOptions={loadUsuarios}
              defaultOptions={false}
              value={novoUsuario}
              onChange={setNovoUsuario}
              placeholder="Buscar usuário..."
              noOptionsMessage={() => 'Digite ao menos 2 letras'}
              styles={customStyles}
              components={{ DropdownIndicator }}
            />
          </div>
          <Button size="sm" variant="success" onClick={handleAdicionar} disabled={!novoUsuario || adicionando}>
            <FaPlus style={{ marginRight: 4 }} />
            Adicionar
          </Button>
        </div>

        {loading ? (
          <div className="text-center py-3">Carregando...</div>
        ) : (
          <Table size="sm" hover style={{ fontSize: 13 }}>
            <thead style={{ background: '#f4f5f7' }}>
              <tr>
                <th>Usuário</th>
                <th style={{ width: 80 }}>Ação</th>
              </tr>
            </thead>
            <tbody>
              {validadores.length === 0 ? (
                <tr><td colSpan={2} className="text-center text-muted py-3">Nenhum validador cadastrado</td></tr>
              ) : validadores.map((v) => (
                <tr key={v.codigo_usuario}>
                  <td>{v.nome_completo}</td>
                  <td>
                    <Button size="sm" variant="outline-danger" onClick={() => handleExcluir(v.codigo_usuario)}>
                      <FaTrash />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onClose}>
          <FaTimes style={{ marginRight: 4 }} />
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalValidarCotacao;
